<app-styled-banner [banner]='banner'></app-styled-banner>
<app-international-event-gallery [events]='events'></app-international-event-gallery>